import "./index.scss";

import { Box } from "@mui/material";
import LabelWithValue from "components/LabelWithValue";
import TitleWithOptions from "components/TitleWithOptions";
import { TMemberDetails } from "models/member";

export default function SystemOptionSection(props: {
  member: TMemberDetails;
  editCallback: Function;
}) {
  const { member, editCallback } = props;

  return (
    <div className="system-option-container">
      <TitleWithOptions title="System Options" buttonClass="white-background" edit={editCallback} />
      <Box display="flex" gap={1} flexDirection="column" mt={2}>
        <LabelWithValue
          label="Training Partner Sounds"
          value={
            (member?.system_options?.training_partner_sounds_on &&
            member?.system_options?.training_partner_sounds_on === 0
              ? `All Sounds Off`
              : member?.system_options?.training_partner_sounds_on === 1
              ? `All Sounds On`
              : `Warning Sounds Off`) || `N/A`
          }
        />
        <LabelWithValue
          label="Change Weights"
          value={
            member?.system_options?.change_weights === null
              ? `N/A`
              : member?.system_options?.change_weights
              ? `Yes`
              : `No`
          }
        />
        <LabelWithValue
          label="Change Settings"
          value={
            member?.system_options?.change_settings === null
              ? `N/A`
              : member?.system_options?.change_settings
              ? `Yes`
              : `No`
          }
        />
      </Box>
    </div>
  );
}
